import { useEffect, useState } from 'react';
import { GetCostBreakdownResponseModel } from '../services/quote.interfaces';
import { getCostBreakdown } from '../services/quote.service';

export const useGetCostBreakdown = (quoteRef: string, trackingRef: string) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [costBreakdown, setCostBreakdown] =
    useState<GetCostBreakdownResponseModel | null>(null);

  const [errors, setErrors] = useState<any>();

  useEffect(() => {
    async function fetchCostBreakdown() {
      try {
        const response = await getCostBreakdown(quoteRef, trackingRef);
        if (response.data) {
          setIsLoading(false);
          setCostBreakdown(response.data);
        }
      } catch (error) {
        setIsLoading(false);
        setErrors(error);
      }
    }

    if (quoteRef) {
      fetchCostBreakdown();
    }
  }, [quoteRef, trackingRef]);

  return [costBreakdown, errors, isLoading];
};
